<!--
 * @Description: hw16v
 * @Date: 2024-01-18 11:09:50
 * @Author: caogt
-->
<template>
  <div class="template-container">
    <div class="main-box1">
      <div class="box1-bg"></div>
      <div class="box1-bg2"></div>
      <div class="text-box">
        <div class="text-top">
          <div class="text-item" style="flex: 1">
            <div class="top-text1">HW-25H</div>
            <div>{{ $t('hw25h.text1') }}</div>
          </div>
          <img class="img-lj" src="/static/images/v2/600h/lj.png">
          <div class="text-item">
            <div class="top-text2">10kg</div>
            <div class="top-text2-1">{{ $t('hw25h.text2') }}</div>
          </div>
          <img class="img-lj" src="/static/images/v2/600h/lj.png">
          <div class="text-item" style="width: auto">
            <div class="top-text2">120min</div>
            <div class="top-text2-1">{{ $t('hw25h.text3') }}</div>
          </div>
        </div>
        <div class="box1-intro">
          {{ $t('hw25h.text4') }}
        </div>
      </div>
    </div>
    <div class="main-box2">
      <div class="box2-bg"></div>
      <div class="box2-list">
        <div class="box2-list-item" v-for="(item,index) in $t('hw25h.list')" :key="index">
          <img class="box2-icon" :src="item.icon">
          <div class="box2-text">{{item.title}}
            <div class="box2-text-info">
              {{item.info}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-box3">
      <div class="box3-content">
      </div>
    </div>
<!--    <div class="main-box4">-->
<!--      <div  class="box4-bg">-->
<!--      <div class="box3-params">-->
<!--        <div class="params-title">{{ $t('hw25h.text5') }}</div>-->
<!--        <div class="params-grid">-->
<!--          <div class="params-grid-item" v-for="(item,index) in $t('hw25h.paramsList')" :key="index">-->
<!--            {{item.title}}-->
<!--            <div class="grid-item-text">-->
<!--              <div class="grid-line"></div>-->
<!--              <div class="grid-tip">-->
<!--                {{item.info}}-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script type="text/ecmascript-6">
// import { isMobileDevice } from '@/common/scripts/isMobile.js';

export default {
  data() {
    return {

    };
  },
  mounted() {
  },
  methods: {},
};
</script>

<style scoped lang="stylus">
.template-container {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;

  .main-box1 {
    position: relative;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    background-size: cover;
    background-position: center;
    background-image: url("/static/images/v2/25h/25h_bg1.png");
    width: 100%;
    height: calc(100vh - 60px);

    .box1-bg {
      top: 0;
      position: absolute;
      width: 100%;
      height: 10.4vw;
      background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
    }
    .box1-bg2 {
      bottom: 0;
      position: absolute;
      width: 100%;
      height: 300px;
      background: linear-gradient(0deg, #000000 0%, rgba(255, 255, 255, 0) 100%);
    }

    .box1-intro {
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
    }

    .text-box {
      position: absolute;
      width: 1280px;
      color: #fff;
      margin-bottom: 50px;
    }

    .img-lj {
      width: 52px;
      height: 52px;
      margin-right: 15px;
    }

    .text-item {
      color: #C1C7C9;
      font-size: 24px;
      font-weight: 500;
      width: 225px;
    }

    .text-top {
      align-items: center;
      width: 100%;
      display: flex;
      padding-bottom: 20px;
      border-bottom: 1px solid #C0C1BD;
      margin-bottom: 40px;
    }

    .top-text1 {
      color: #FFFFFF;
      font-size: 64px;
      font-weight: 800;
      margin-bottom: 12px;
    }

    .top-text2 {
      color: #FFFFFF;
      font-size: 36px;
      font-weight: 900;
      margin-bottom: 12px;
    }
  }

  .main-box2 {
    position: relative;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    width: 100%;
    height: calc(120vh);
    background-size: cover;
    background-position: center;
    background-image: url("/static/images/v2/25h/25h_bg2.png");

    .box2-bg {
      top: 0;
      position: absolute;
      width: 100%;
      height: calc(120vh);
      background: linear-gradient(0deg, #222222 5%, rgba(37, 37, 37, 0.58) 46%, rgba(39, 39, 39, 0) 70%, rgba(42, 42, 42, 0) 100%);
    }

    .box2-list {
      box-sizing: border-box;
      padding: 57px 180px;
      position: absolute;
      z-index: 2;
      width: 1280px;
      height: auto;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0.5) 20%, rgba(0, 0, 0, 0) 69%);
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 218px;
      row-gap: 40px;
      border-bottom: 1px solid #464646;
    }

    .box2-list-item {
      display: flex;
    }

    .box2-icon {
      object-fit: contain;
      margin-right: 25px;
      width: 45px;
      height: 45px;
    }

    .box2-text {
      font-size: 24px;
      font-weight: 600;
      color: #568BFF;
    }

    .box2-text-info {
      margin-top: 10px;
      font-size: 14px;
      font-weight: 600;
      line-height: 22px;
      color: #fff;
    }
  }

  .main-box3 {
    color: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background: #222222;

    .box3-content {
      width: 1280px;
    }

    .box3-title {
      margin-top: 115px;
      font-size: 48px;
      font-weight: 600;
      background: linear-gradient(167deg, #7DDAFF 30%, #1E92F7 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }

    .box3-text {
      margin: 30px 0;
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
      width: 573px;
    }

    .box3-img {
      display: flex;
    }

    .box3-img-item1 {
      width: 513px;
      height: 354px;
    }

    .box3-img-item2 {
      margin-left: 30px;
      flex: 1;
      height: 354px;
    }
    .box3-load-list{
      margin-top: 75px;
      margin-bottom: 150px;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      column-gap: 7px;
      row-gap: 7px;
    }
    .load-list-item{
      padding-bottom: 12px;
      box-sizing: border-box;
      align-items: flex-end;
      display: flex;
      justify-content: center;
      color: #1B1B1B;
      background: #fff;
      height: 190px;
      border-radius: 14px;
      position: relative;
      font-size: 18px;
      font-weight: 600;
    }
    .list-item-img{
      top: 0;
      position: absolute;
    }
  }
  .main-box4{
    width: 100%;
    background-size: cover;
    background-position: top;
    background-image: url("/static/images/v2/25h/25h_bg3.png");
   .box4-bg{
     padding-top: 70px;
     padding-bottom: 200px;
     background: rgba(2,21,72, 0.6);
     width: 100%;
     height: 100%;
   }
    .box3-params {
      color: #FFFFFF;
      margin-left: calc((100% - 1280px) / 2);
      width: 1280px;
    }
    .params-title{
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);
      font-size: 48px;
      font-weight: 600;
      padding-bottom: 30px;
      margin-bottom: 75px;
    }
    .params-grid{
      font-size: 24px;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
      column-gap: 2px;
      row-gap: 135px;
    }
    .params-grid-item{
      padding-left: 70px;
      font-weight: 600;
    }
    .grid-item-text{
      margin-top: 24px;
      display: flex;
      font-size: 16px;
    }
    .grid-line{
      margin-right: 18px;
      width: 2px;
      height: 22px;
      opacity: 0.4;
      background: #FFFFFF;
    }
    .grid-tip{
      flex: 1;
      line-height: 32px;
      font-size: 16px;
    }
  }
}

@media all and (max-width: 768px) {
  .template-container {
    overflow: hidden;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;

    .main-box1 {
      position: relative;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      background-size: cover;
      background-position: center;
      background-image: url("/static/images/v2/25h/25h_bg1.png");
      width: 100%;
      height: calc(100vh - 60px);

      .box1-bg {
        top: 0;
        position: absolute;
        width: 100%;
        height: 10.4vw;
        background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
      }
      .box1-bg2 {
        bottom: 0;
        position: absolute;
        width: 100%;
        height: 300px;
        background: linear-gradient(0deg, #000000 0%, rgba(255, 255, 255, 0) 100%);
      }

      .box1-intro {
        margin: 0 20px;
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
      }

      .text-box {
        position: absolute;
        width: 100%;
        color: #fff;
        margin-bottom: 50px;
      }

      .img-lj {
        display: none;
        width: 52px;
        height: 52px;
        margin-right: 15px;
      }

      .text-item {
        margin-left: 20px;
        width: 90vw;
        color: #C1C7C9;
        font-size: 24px;
        font-weight: 500;
      }

      .text-top {
        align-items: center;
        width: 100%;
        display: flex;
        padding-bottom: 20px;
        border-bottom: 1px solid #C0C1BD;
        margin-bottom: 40px;
      }

      .top-text1 {
        color: #FFFFFF;
        font-size: 64px;
        font-weight: 800;
        width: 90vw;
        margin-bottom: 12px;
      }

      .top-text2 {
        display: none;
        color: #FFFFFF;
        font-size: 36px;
        font-weight: 900;
        margin-bottom: 12px;
      }
      .top-text2-1{
        display: none;
      }
    }

    .main-box2 {
      position: relative;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      width: 100%;
      height: calc(160vh);
      background-size: cover;
      background-position: top;
      background-image: url("/static/images/v2/25h/25h_bg2.png");

      .box2-bg {
        top: 0;
        position: absolute;
        width: 100%;
        height: calc(160vh);
        background: linear-gradient(0deg, #222222 5%, rgba(37, 37, 37, 0.58) 46%, rgba(39, 39, 39, 0) 70%, rgba(42, 42, 42, 0) 100%);
      }

      .box2-list {
        margin: 0 20px;
        box-sizing: border-box;
        padding: 10px 10px;
        position: absolute;
        z-index: 2;
        width: auto;
        height: auto;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.5) 20%, rgba(0, 0, 0, 0) 69%);
        display: grid;
        grid-template-columns: 1fr;
        column-gap: 218px;
        row-gap: 40px;
        border-bottom: 1px solid #464646;
      }

      .box2-list-item {
        display: flex;
      }

      .box2-icon {
        object-fit: contain;
        margin-right: 25px;
        width: 45px;
        height: 45px;
      }

      .box2-text {
        font-size: 24px;
        font-weight: 600;
        color: #568BFF;
      }

      .box2-text-info {
        margin-top: 10px;
        font-size: 14px;
        font-weight: 600;
        line-height: 22px;
        color: #fff;
      }
    }

    .main-box3 {
      color: #FFFFFF;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      background: #222222;

      .box3-content {
        width: 100%;
      }

      .box3-title {
        margin-left: 5vw;
        margin-top: 115px;
        font-size: 48px;
        font-weight: 600;
        background: linear-gradient(167deg, #7DDAFF 30%, #1E92F7 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }

      .box3-text {
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
        width: 90vw;
        margin-left: 5vw;
      }

      .box3-img {
        display: flex;
        flex-direction: column;
      }

      .box3-img-item1 {
        width: 90vw;
        margin-left: 5vw;
        height: auto;
      }
      .box3-img-item2 {
        margin-top: 20px;
        margin-left: 5vw;
        flex: auto;
        width: 90vw;
        height: auto;
      }
      .box3-load-list{
        margin: 0 5vw;
        margin-top: 75px;
        margin-bottom: 150px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 7px;
        row-gap: 7px;
      }
      .load-list-item{
        padding-bottom: 12px;
        box-sizing: border-box;
        align-items: flex-end;
        display: flex;
        justify-content: center;
        color: #1B1B1B;
        background: #fff;
        height: 190px;
        border-radius: 14px;
        position: relative;
        font-size: 18px;
        font-weight: 600;
      }
      .list-item-img{
        top: 0;
        position: absolute;
      }
    }
    .main-box4{
      width: 100%;
      background-size: cover;
      background-position: center;
      background-image: url("/static/images/v2/25h/25h_bg3.png");
      .box4-bg{
        padding-top: 70px;
        padding-bottom: 200px;
        background: rgba(0, 0, 0, 0.4);
        width: 100%;
        height: 100%;
      }
      .box3-params {
        color: #FFFFFF;
        margin-left: 0;
        width: 100%;
      }
      .params-title{
        margin-left: 5vw;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
        font-size: 48px;
        font-weight: 600;
        padding-bottom: 30px;
        margin-bottom: 75px;
      }
      .params-grid{
        font-size: 24px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 2px;
        row-gap: 135px;
      }
      .params-grid-item{
        padding-left: 20px;
        font-weight: 600;
      }
      .grid-item-text{
        margin-top: 24px;
        display: flex;
        font-size: 16px;
      }
      .grid-line{
        margin-right: 18px;
        width: 2px;
        height: 22px;
        opacity: 0.4;
        background: #FFFFFF;
      }
      .grid-tip{
        flex: 1;
        line-height: 32px;
        font-size: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/industry/zt/hw25h.vue